window.$ = window.jQuery = require('jquery'); // jQuery
